"use strict";

var _defineProperty = require("/mnt/largevol/jenkins_root/jobs/external-site-build/workspace/node_modules/@babel/runtime/helpers/defineProperty.js");
var _slicedToArray = require("/mnt/largevol/jenkins_root/jobs/external-site-build/workspace/node_modules/@babel/runtime/helpers/slicedToArray.js");
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearQueryParam = exports.setQueryParams = exports.getQueryParams = exports.useQueryParamString = exports.queryParamsEventEmitter = void 0;
var react_1 = __importDefault(require("react"));
var queryString = __importStar(require("query-string"));
var events_1 = require("events");
var react_sub_unsub_1 = require("react-sub-unsub");
exports.queryParamsEventEmitter = new events_1.EventEmitter();
exports.queryParamsEventEmitter.setMaxListeners(100);
function useQueryParamString(key, defaultValue) {
  var clearOnDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _react_1$default$useS = react_1.default.useState(false),
    _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
    initialized = _react_1$default$useS2[0],
    setInitialized = _react_1$default$useS2[1];
  var _react_1$default$useS3 = react_1.default.useState(0),
    _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
    updateTime = _react_1$default$useS4[0],
    setUpdateTime = _react_1$default$useS4[1];
  var _react_1$default$useS5 = react_1.default.useState(defaultValue),
    _react_1$default$useS6 = _slicedToArray(_react_1$default$useS5, 2),
    value = _react_1$default$useS6[0],
    setStateValue = _react_1$default$useS6[1];
  var clear = react_1.default.useCallback(function () {
    clearQueryParam(key);
  }, [key]);
  var setValue = react_1.default.useCallback(function (val) {
    setStateValue(val);
    if (clearOnDefault && val === defaultValue) {
      clear();
    } else {
      setQueryParams(Object.assign(Object.assign({}, getQueryParams()), _defineProperty({}, key, val)));
    }
  }, [clear, clearOnDefault, defaultValue, key]);
  var fetchValue = react_1.default.useCallback(function () {
    var queryParams = getQueryParams();
    var v = queryParams[key];
    setStateValue(typeof v === 'string' ? v : defaultValue);
  }, [defaultValue, key]);
  react_1.default.useEffect(function () {
    if (!initialized) {
      fetchValue();
      setInitialized(true);
    }
  }, [fetchValue, defaultValue, initialized, key]);
  react_1.default.useEffect(function () {
    if (updateTime > 0) {
      fetchValue();
    }
  }, [fetchValue, updateTime]);
  react_1.default.useEffect(function () {
    var subs = new react_sub_unsub_1.Subs();
    subs.subscribeEvent(exports.queryParamsEventEmitter, 'update', function () {
      setUpdateTime(Date.now());
    });
    return subs.createCleanup();
  }, []);
  return [value, setValue, initialized, clear];
}
exports.useQueryParamString = useQueryParamString;
/**
 * Retrieve a map of the decoded query params from `window.location.search`.
 */
function getQueryParams() {
  var queryParams = {};
  if (typeof window !== 'undefined') {
    queryParams = queryString.parse(window.location.search);
  }
  return queryParams;
}
exports.getQueryParams = getQueryParams;
/**
 * Set the query params (without affecting the router).
 */
function setQueryParams(query) {
  if (typeof window !== 'undefined') {
    var hasKeys = Object.keys(query).length > 0;
    var urlSuffix = hasKeys ? "?".concat(queryString.stringify(query)) : '';
    window.history.replaceState(window.history.state, '', "".concat(window.location.pathname).concat(urlSuffix));
    exports.queryParamsEventEmitter.emit('update');
  }
}
exports.setQueryParams = setQueryParams;
/**
 * Remove a query param key from the URL entirely.
 */
function clearQueryParam(key) {
  var queryParams = getQueryParams();
  delete queryParams[key];
  setQueryParams(queryParams);
}
exports.clearQueryParam = clearQueryParam;